import { defineComponent } from 'vue';
import CrmId from '@/presentation/components/campaign-management/crm-id/crm-id.vue';
import Region from '@/presentation/components/campaign-management/region/region.vue';
import Currency from '@/presentation/components/campaign-settings/currency/currency';
import LoadingWrapper from '@/presentation/components/shared/loading-wrapper/loading-wrapper.vue';
import CrmRegionWrapperCode from '@/presentation/components/campaign-management/crm-region-wrapper/crm-region-wrapper.code';

export default defineComponent({
	components: {
		LoadingWrapper,
		Currency,
		CrmId,
		Region
	},
	setup: () => {
		const code = new CrmRegionWrapperCode();
		return {
			isLoading: code.isLoading,
			validationMessage: code.validationMessage,
			isFieldValidatedAndMissing: code.isFieldValidatedAndMissing,
			isFieldValidatedAndInvalid: code.isFieldValidatedAndInvalid
		};
	}
});
